export default function Footer() {
    return (
        <footer className="text-center mt-4 py-3">
            <p>&copy; Dominik Pych</p>
        </footer>
    );
}
